// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3OmvM","checkboxCol":"Table_checkboxCol__1lwve","emailCol":"Table_emailCol__2-Tm7","actionCol":"Table_actionCol__3GSv_"};